import { editPlan } from './admin/plans/edit-plan';
import { deletePlan } from './admin/plans/delete-plan';
import { createService } from './admin/services/create-service';
import { getUserSubscriptions } from './admin/get-user-subscriptions';
import { getAllFrequencies } from './admin/frequencies/get-all';
import { getAllServices } from './admin/services/get-all-services';
import { updateService } from './admin/services/update-service';
import { createPlan } from './admin/plans/create-plan';
import { createAdminSubscription } from './admin/subscriptions/create-admin-subscription';

export const subscriptionsSDK = {
    admin: {
        getUserSubscriptions,
        plans: {
            edit: editPlan,
            delete: deletePlan,
            create: createPlan,
        },
        services: {
            create: createService,
            getAll: getAllServices,
            update: updateService,
        },
        frequencies: {
            getAll: getAllFrequencies,
        },
        subscriptions: {
            create: createAdminSubscription,
        },
    },
};
